export function mobileNav() {
    const body = $("body");
    const $window = $(window);
    const btnMenu = $(".btn-menu");
    const arrowLink = `<span class="arrow"><svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 1.54009C0 1.14461 0.157853 0.764342 0.457774 0.460126C1.0734 -0.133094 2.08366 -0.133094 2.69929 0.460126L7.49803 5.06899L12.2968 0.444915C12.9124 -0.148305 13.9227 -0.148305 14.5383 0.444915C15.1539 1.03814 15.1539 2.01163 14.5383 2.60485L8.61878 8.30889C8.31886 8.59789 7.92423 8.75 7.49803 8.75C7.07182 8.75 6.67719 8.58268 6.37727 8.30889L0.457774 2.62006C0.157853 2.31584 0 1.92036 0 1.54009Z" fill="white"/>
</svg></span>`;

    btnMenu.on("click", function (e) {
        let $this = $(this);
        if (!$this.hasClass("open")) {
            $this.addClass("open");
            body.addClass("menu-opened");
        } else {
            $this.removeClass("open");
            body.removeClass("menu-opened");
        }
        e.preventDefault();
    });

    $(arrowLink).insertBefore(".sub-menu");

    $(document).on("click", ".main-nav .arrow", function () {
        let $this = $(this);
        let parent = $this.parent();
        if ($window.width() < 1200) {
            if (!parent.hasClass("active")) {
                parent.addClass("active").find(".sub-menu").slideDown();
            } else {
                parent.removeClass("active").find(".sub-menu").slideUp();
            }
        } else {
            if (!parent.hasClass("active")) {
                parent.addClass("active").find(".sub-menu").fadeIn();
            } else {
                parent.removeClass("active").find(".sub-menu").fadeOut();
            }
        }
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js